module.exports = __webpack_public_path__ + "static/media/pagcorlogo2.ef4b2f70.svg";